export const ACCEPTANCE_SOURCE = 'webapp'

export const DOCUMENT_KEYS = {
  termsOfService: 'terms_of_service',
  privacyPolicy: 'privacy_policy',
  winitLawTermsOfService: 'winitlaw_terms_of_service',
  winitLawPrivacyPolicy: 'winitlaw_privacy_policy',
  attorneyRetainerAgreement: 'attorney_retainer_agreement',
  financingTerms: 'financing_terms',
  marketingConsent: 'marketing_consent',
  parkingDisclaimer: 'parking_disclaimer',
  trafficDisclaimer: 'traffic_disclaimer',
}

// "Last Updated" dates: content/termsOfUse.md, content/privacyPolicy.md, content/financingTermsOfUse.md
// and winitlaw.com/privacy-policy. Documents without a published date use 2026-10.
export const DOCUMENT_VERSIONS = {
  termsOfService: '2026-03',
  privacyPolicy: '2023-03',
  financingTerms: '2025-01',
  winitLawTermsOfService: '2026-10',
  winitLawPrivacyPolicy: '2023-10-12',
  winitLawFinancingTerms: '2026-10',
  attorneyRetainerAgreement: '2026-10',
  marketingConsent: '2026-10',
  parkingDisclaimer: '2026-10',
  trafficDisclaimer: '2026-10',
}

const acceptance = (documentKey, documentVersion) => ({ documentKey, documentVersion })

const byName = name => acceptance(DOCUMENT_KEYS[name], DOCUMENT_VERSIONS[name])

const winitLawFinancing = () =>
  acceptance(DOCUMENT_KEYS.financingTerms, DOCUMENT_VERSIONS.winitLawFinancingTerms)

const termsAndPrivacy = isWinitLaw =>
  isWinitLaw
    ? [byName('winitLawTermsOfService'), byName('winitLawPrivacyPolicy')]
    : [byName('termsOfService'), byName('privacyPolicy')]

export const signupModalAcceptances = () => [...termsAndPrivacy(false), byName('marketingConsent')]

export const userInfoAcceptances = isWinitLaw => [
  ...termsAndPrivacy(isWinitLaw),
  byName('marketingConsent'),
]

const winitTrafficCheckout = isPaymentPlan => [
  byName('attorneyRetainerAgreement'),
  byName('termsOfService'),
  ...(isPaymentPlan ? [byName('financingTerms')] : []),
  byName('trafficDisclaimer'),
]

const winitLawTrafficCheckout = isPaymentPlan => [
  ...termsAndPrivacy(true),
  byName('attorneyRetainerAgreement'),
  ...(isPaymentPlan ? [winitLawFinancing()] : []),
]

export const trafficCheckoutAcceptances = ({ isWinitLaw, isPaymentPlan }) =>
  isWinitLaw ? winitLawTrafficCheckout(isPaymentPlan) : winitTrafficCheckout(isPaymentPlan)

export const parkingCheckoutAcceptances = isPayFlow =>
  isPayFlow ? [...termsAndPrivacy(false), byName('parkingDisclaimer')] : termsAndPrivacy(false)

export const parkingNotifyAcceptances = () => [
  byName('marketingConsent'),
  byName('termsOfService'),
  byName('parkingDisclaimer'),
]
